import { useTranslation } from "react-i18next";

export default function TypeOfPermit({ setTypeOfPermit, typeOfPermit }) {
  const { t } = useTranslation();
  function onChange(event) {
    setTypeOfPermit(event);
  }

  return (
    <div className="col-6 type-of-permit">
      <h1>{t("Type of Permit")}</h1>
      <input
        type="text"
        className="form-control"
        id="permit"
        name="permit"
        placeholder={t("Type of Permit")}
        onChange={onChange}
        value={typeOfPermit}
      />
    </div>
  );
}
